// This is a replacement for `src/components/App/App.tsx`.
import { observer } from 'mobx-react-lite';

import { UnobservedApp } from './UnobservedApp';

export const App = observer(UnobservedApp);
export default App;
